<template>
  <div :class="$style.box">
    <div :class="$style.firstScreen">
      <h1 :class="$style.slogan">
        {{ content.servicesSlogan1 }}
        <br>
        {{ content.servicesSlogan2 }}
      </h1>
      <p
        :class="$style.text"
        v-for="(item,index) in content.servicesText "
        :key="index"
        v-html="item"
      >
      </p>
    </div>

    <div :class="$style.secondScreen">
      <p
        :class="$style.text"
        v-for="(item,index) in content.aboutText "
        :key="index+'a'"
      >
        {{ item }}
      </p>
      <hr>
      <p>
        get in touch
      </p>
    </div>

    <!-- <h1 :class="$style.sectionTitle">{{ content.aboutTitle1 }}</h1>
    <div :class="$style.sectionMain">
      <p
        :class="$style.text"
        v-for="(item,index) in content.aboutText1 "
        :key="index+'a'"
      >
        {{ item }}
      </p>
    </div>

    <h1 :class="$style.sectionTitle">{{ content.aboutTitle2 }}</h1>
    <div :class="$style.sectionMain">
      <p
        :class="$style.text"
        v-for="(item,index) in content.aboutText2 "
        :key="index+'b'"
      >
        {{ item }}
      </p>

      <a href="www.baidu.com">联系我们</a>
    </div> -->
    <!-- </div> -->
  </div>
</template>

<script>

export default {
  name: 'About',
  props: ['content']

}
</script>
<style scoped>

</style>

<style module>
.box {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.firstScreen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  padding: 24px;
  height: 100vh;
  width: 100%;
  max-width: 1100px;
  /* background: rgba(0, 222, 19, 0.2) */
}

.slogan {
  font-size: 53px;
  margin-bottom: 53px;
  opacity: 0.2;
}

.secondScreen {
  height: 30vh;
}

.text {
  font-size: 20px;
  line-height: 1.7;
  margin-bottom: 36px;
  width: 800px;
}
</style>
